// TYPES
import type { FailedResponse, SuccessResponse } from '..'

// UTILITIES
import { isNonEmptyString } from '@utils/type-checkers'
import { generateHeaders, createResponseObj } from '..'
import { personaBaseUrl } from '.'


type CreateInquiryResponse = (SuccessResponse & {
    inquiry: {
        id: string
        sessionToken: string
        status: string
    }
}) | FailedResponse

export class CreateInquiryRequest extends Request {
    private constructor(userId: string, init?: RequestInit) { super(`${personaBaseUrl}/user/${userId}/inquiry`, init) }
    static async init(userId: string | undefined, init?: RequestInit) {
        if (!isNonEmptyString(userId)) throw createResponseObj<FailedResponse>({ status: 'failed', type: 'local', name: 'invalid-user-id ', message: 'Invalid User Id' })
        else return new CreateInquiryRequest(userId, {
            ...init,
            method: 'POST',
            headers: await generateHeaders("Clerk-Token", init?.headers),
        })
    }

    static async fetch(...args: Parameters<typeof this.init>) {
        const request = await this.init(...args)
        return await request.fetch()
    }

    public async fetch(): Promise<{ id: string, sessionToken: string, status: string }> {
        const response = await fetch(this)
        const data = createResponseObj<CreateInquiryResponse>(await response.json())
        console.info("Create Inquiry Results:", data)

        switch (data.status) {
            case 'successful': return data.inquiry
            case 'failed': throw data
            default: throw new Error(`Unsupported Status: ${data}`)
        }
    }
}